export const nodeCountSingularScreenReaderOnlyText = "COV9Bb";
export const nodeCountPluralScreenReaderOnlyText = "lLnreb";
export default {nodeCountSingularScreenReaderOnlyText,nodeCountPluralScreenReaderOnlyText};